import Avatar from "../../avatar";
import Typo from "../../typo";
import {SwiperSimpleCarousel} from "../../swiper";
import {SwiperSlide} from "swiper/react";
import FileView from "../../file-view";

const ExperienceCard = ({
  covers,
  name,
  avatar,
  type,
  missionName,
  title,
  content,
  time,
  onAvatarClick,
  onClick,
}) => {
  return (
    <div className="flex w-full shrink-0 flex-col gap-2 rounded-xl bg-white p-3" onClick={() => onClick()}>
      <div className="flex items-center justify-between gap-2">
        <div
          className="flex items-center gap-1"
          onClick={(e) => {
            e.stopPropagation();
            onAvatarClick();
          }}
        >
          <Avatar image={avatar} name={name} size="2xs" />
          <Typo size="xs" weight="bold">
            {name}
          </Typo>
        </div>
        <Typo type="secondary" className="rounded-full bg-purple-5 px-2" size="xs">
          {type}
        </Typo>
      </div>
      <SwiperSimpleCarousel loop pagination navigation className="w-full">
        {covers.map((cover, i) => (
          <SwiperSlide key={'SwiperCoverExperienceCard' + cover?.id + '_' + i} className="w-full overflow-hidden rounded-xl">
            <FileView {...cover} thumbnail={undefined} controls className="h-full w-full bg-cover" />
          </SwiperSlide>
        ))}
      </SwiperSimpleCarousel>
      <Typo as="h2" weight="bold">
        {missionName}
      </Typo>
      <Typo as="h2" weight="bold" size="sm">
        {title}
      </Typo>
      <Typo type="secondary" size="xs" className="ui-clamp-3">
        {content}
      </Typo>
      <Typo type="secondary" size="xs" className="mt-auto opacity-50">
        {time}
      </Typo>
    </div>
  );
};

export default ExperienceCard;
